/* eslint-disable @next/next/no-img-element */
import InstantArticle from "views/articles/InstantArticle"
import addToHomeScreen from "views/articles/AddToHomeScreen"
import Link from "next/link"
import shareButtonPhoto from "views/articles/AddToHomeScreen/share-button.jpg"
import addToHomeScreenPhoto from "views/articles/AddToHomeScreen/add-to-home-screen-button.jpg"
import addButtonPhoto from "views/articles/AddToHomeScreen/add-button.jpg"
import homeScreenPhoto from "views/articles/AddToHomeScreen/home-screen.jpg"
import InstallAppollowVideo from "./InstallAppollowVideo"

const AddAppollowToYourHomeScreenEN = () => {
  const article = addToHomeScreen["en"]
  return (
    <InstantArticle {...article}>
      <div style={{ textAlign: "justify" }}>
        <p>
          Appollow is built with Progressive Web Apps (PWAs) technology which is
          a type of web application that offers a native app-like experience to
          users. They can be installed on a device&quot;s home screen and
          launched just like a native app, without the need for a separate
          download from an app store.
        </p>
        <p>
          Installing Appollow on the home screen of an iOS device, such as an
          iPhone or iPad, can offer several benefits.
        </p>
        <h2>Benefits of installing Appollow on the home screen:</h2>
        <ul>
          <li>
            <b>Improved performance:</b> Appollow is designed to be fast and
            efficient, with a focus on delivering a seamless user experience. By
            installing Appollow on the home screen, you can enjoy the benefits
            of a native app, such as faster loading times and offline
            functionality, without the need to download and install a separate
            app.
          </li>
          <li>
            <b>Easier access:</b> Installing Appollow on the home screen allows
            you to access the app with just one tap, without the need to open a
            web browser and search for the app. This can be especially useful if
            you want to use the app more frequently.
          </li>
          <li>
            <b>Up-to-date content:</b> Appollow can be updated automatically and
            super quickly, so users can always have access to the latest
            features and content. This is in contrast to native apps, which
            require users to manually update them from the app store.
          </li>
        </ul>
        <h2>How to install Appollow on your home screen using Safari:</h2>
        <ol>
          <li>
            Open Safari and navigate to{" "}
            <Link href="https://www.appollow.net">Appollow</Link>
          </li>
          <li>
            Tap the Share button (the square with an arrow pointing out of it)
            at the bottom of the screen.
          </li>
          <div className="text-center ms-n4">
            <img
              src={shareButtonPhoto.src}
              alt="share button"
              className="mb-3 rounded-sm"
              width="100%"
              style={{ maxWidth: 450 }}
            />
          </div>
          <li>
            Scroll down and tap the &quot;Add to Home Screen&quot; option.
          </li>
          <div className="text-center ms-n4">
            <img
              src={addToHomeScreenPhoto.src}
              alt="share button"
              className="mb-3 rounded-sm"
              width="100%"
              style={{ maxWidth: 450 }}
            />
          </div>
          <li>
            A prompt will appear asking you to confirm the installation. Tap
            &quot;Add&quot; to proceed.
          </li>
          <div className="text-center ms-n4">
            <img
              src={addButtonPhoto.src}
              alt="share button"
              className="mb-3 rounded-sm"
              width="100%"
              style={{ maxWidth: 450 }}
            />
          </div>
          <li>
            The PWA will be added to the home screen of your device and can be
            launched just like a native app.
          </li>
          <div className="text-center ms-n4">
            <img
              src={homeScreenPhoto.src}
              alt="share button"
              className="mb-3 rounded-sm"
              width="100%"
              style={{ maxWidth: 450 }}
            />
          </div>
        </ol>
        <InstallAppollowVideo />
        <p>
          enjoy using the app right from your home screen with the improved
          performance, easier access, and up-to-date content. Let us know if you
          have any suggestions for features you like to see in future versions
          of Appollow by contacting us through the{" "}
          <Link href="/contact">contact us</Link> page.
        </p>
      </div>
    </InstantArticle>
  )
}

export default AddAppollowToYourHomeScreenEN
